export default "__VITE_ASSET__CaC4howW__"